import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;
const { colors } = constants;

export const PANEL_HEADER_HEIGHT = 80;

export const rootCss = (shouldRemoveBorderBottom) => ({
  position: "relative",
  alignItems: "center",
  borderBottom: shouldRemoveBorderBottom
    ? "none"
    : `1px solid ${colors.ui.neutral[100]}`,
  display: "flex",
  height: `${PANEL_HEADER_HEIGHT}px`,
  justifyContent: "space-between",
  padding: "12px 16px",

  [mediaQuery.downTo(md)]: {
    height: "72px",
    padding: "12px 24px",
  },

  [mediaQuery.between(xs, md)]: {
    padding: "12px 40px",
  },
});

export const centeredTitleCss = {
  position: "absolute",
  transform: "translate(-50%,-50%)",
  left: "50%",
  top: "50%",
};
